import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import '../css/LoginPage.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  // Styles for the toolbar
  const styles = {
    toolbar: {
      display: "flex",
      justifyContent: "flex-start",
      padding: "10px 20px",
      backgroundColor: "#f5f5f5",
      borderBottom: "1px solid #ddd",
      gap: "10px", // Adds space between buttons
    },
    button: {
      padding: "10px 20px",
      fontSize: "16px",
      backgroundColor: "#007bff",
      color: "#fff",
      textDecoration: "none", // Removes underline from links
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
  };

  const handleLogin = () => {

    if (username === 'admin' && password === 'admin') {
      // 模擬登入成功（實際開發中應從 API 獲取用戶數據）
      const userData = { username: 'admin', role: 'admin' }; // 假設這是從 API 返回的用戶數據
      login(userData);

      // Redirect to the Scheduling page
      navigate('/db');

    } else if (username === 'admin2388' && password === 'admin2388') {
      // 模擬登入成功（實際開發中應從 API 獲取用戶數據）
      const userData = { username: 'admin-super', role: 'admin-super' }; // 假設這是從 API 返回的用戶數據
      login(userData);

      // Redirect to the Scheduling page
      navigate('/dms');

    } else {
      alert('Invalid credentials. Please try again.');
    }


  };

  return (
    <div>
      {/* Top Toolbar with Links */}
      <div style={styles.toolbar}>
        <a
          href="https://www.magicofhappiness.net/ambassador/checkIn/"
          style={styles.button}
        >
          Check-In Form
        </a>
        <a
          href="https://main.d2fzi6aakzazn.amplifyapp.com/general"
          style={styles.button}
        >
          Omni Channel Page (--CI)
        </a>
        <a
          href="https://main.d2fzi6aakzazn.amplifyapp.com/public"
          style={styles.button}
        >
          Omni Channel Page (--NA)
        </a>
        {/* <a
          href="https://main.d2fzi6aakzazn.amplifyapp.com/?serial_number=HKAP0100000001"
          style={styles.button}
        >
          Omni Channel Page (SN=001)
        </a> */}
      </div>
      <div className="login-container">
        <h1 className="login-title">AromaPodPro Admin Panel</h1>
        <div className="login-form">
          <input
            type="text"
            className="login-input"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="password"
            className="login-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <a href="/forgot-password" className="forgot-password">
            Forget password?
          </a>
          <button className="login-button" onClick={handleLogin}>
            Login
          </button>
          <div className="sign-up-link">
            Don't have account? <a href="/register">Sign up</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;